const branch =
  process.env.NEXT_PUBLIC_VERCEL_BRANCH_URL ||
  process.env.GIT_BRANCH ||
  "master";
const dealEndpointDev = "https://contracts-api-dev.hillheli.com/";
const dealEndpointProd = "https://contracts-api.hillheli.com/";

const dealEndpoint = branch.includes("dev")
  ? dealEndpointDev
  : dealEndpointProd;
const dealEndpointV2 = branch.includes("dev")
  ? `${dealEndpointDev}v2/`
  : `${dealEndpointProd}v2/`;

const missedCallsEndpoint = "https://contracts-api.hillheli.com/missed_calls/";
const videoPresentationEndpoint =
  "https://contracts-api.hillheli.com/video_presentation/";
const ownerInvitationEndPoint =
  "https://checkout.oddb.co/products/stock?store=hill";
const liveQaInfo = "https://contracts-api.hillheli.com/live_qa";

const getHeaders = (token) => {
  const header = { "Content-Type": "application/json" };
  if (token) {
    header.Authorization = `Token ${token}`;
  }
  return header;
};

// ##### Simulator  #####

export async function getDeal(id, token) {
  const res = await fetch(`${dealEndpointV2}profile/${id}`, {
    method: "GET",
    headers: getHeaders(token),
  });
  return res;
}

export async function getDealContract(id, token) {
  const res = await fetch(`${dealEndpoint}profile/${id}/contract/`, {
    method: "GET",
    headers: getHeaders(token),
  });
  return res;
}

export async function getHC50DealContract(id, hc50Id, token) {
  const res = await fetch(
    `${dealEndpoint}profile/${id}/hc50/${hc50Id}/contracts/`,
    { method: "GET", headers: getHeaders(token) },
  );
  return res;
}

export async function postDeal(
  id,
  option,
  count,
  type,
  hxId,
  preOrderType,
  token,
) {
  const url =
    type === "hx50"
      ? `${dealEndpoint}profile/${id}/hx50/contracts/`
      : `${dealEndpoint}profile/${id}/simulation/`;
  const body = JSON.stringify(
    hxId
      ? { count, hx50_id: hxId, contract_type: preOrderType }
      : { option, count, contract_type: preOrderType },
  );
  const res = await fetch(url, {
    method: "POST",
    headers: getHeaders(token),
    body,
  });
  return res;
}

export async function postHc50Deal(id, count, preOrderType, token, hcId) {
  const res = await fetch(`${dealEndpoint}profile/${id}/hc50/contracts/`, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(
      hcId
        ? { count, contract_type: preOrderType, hc50_id: hcId }
        : { count, contract_type: preOrderType },
    ),
  });
  return res;
}

export async function signContract(id, token) {
  const res = await fetch(`${dealEndpoint}profile/${id}/sign/`, {
    method: "POST",
    headers: getHeaders(token),
  });
  return res;
}

export async function signHc50Contract(id, hc50Id, token) {
  const res = await fetch(`${dealEndpoint}profile/${id}/hc50/${hc50Id}/sign/`, {
    method: "POST",
    headers: getHeaders(token),
  });
  return res;
}

export async function signHx50Contract(id, hx50Id, token) {
  const res = await fetch(`${dealEndpoint}profile/${id}/hx50/${hx50Id}/sign/`, {
    method: "POST",
    headers: getHeaders(token),
  });
  return res;
}

export async function getDiscount(pid, code) {
  const res = await fetch(`${dealEndpointV2}discount/${code}/user/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ personification_id: pid }),
  });
  return res;
}

// ##### Video Presentation #####

export async function getVideoPresentation(id) {
  const res = await fetch(`${videoPresentationEndpoint}${id}`);
  return res;
}

export async function getMissedCalls(id) {
  const res = await fetch(`${missedCallsEndpoint}${id}`);
  return res;
}

export async function postVideoPresentationQuestion(id, questions) {
  const res = await fetch(`${videoPresentationEndpoint}${id}/submission/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ questions }),
  });
  return res;
}

// #####  OWNER Invitation Stock #####

export async function getLiveQAInfo(code) {
  const res = await fetch(`${liveQaInfo}/${code}/`);
  return res;
}

export async function getMonthlyUpdateQA(profileId) {
  const res = await fetch(
    `https://presentations.hillheli.com/entries/${profileId}`,
  );
  return res;
}

export async function getPeopleMonthlyUpdateQA(peopleId) {
  const res = await fetch(
    `https://presentations.hillheli.com/people/${peopleId}`,
  );
  return res;
}

export async function getSneakPeekData(peopleId) {
  const res = await fetch(
    `https://presentations.hillheli.com/video_updates/update-sneakpeek/users/${peopleId}`,
  );
  return res;
}

// #####  CAREER Job Apply #####
export async function getFormSubmission(formId, accessToken) {
  const res = await fetch(
    `https://api.oddforms.oddb.co/forms/form/${formId}/submission`,
    {
      method: "GET",
      headers: { AccessToken: accessToken },
    },
  );
  return res;
}

export async function getFormCredentials(formId, uuid) {
  const res = await fetch(
    `https://api.oddforms.oddb.co/forms/form/${formId}/user/${uuid}`,
  );
  return res;
}

export async function submitFile(formId, fieldId, file, accessToken) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("field_id", fieldId);

  const res = await fetch(
    `https://api.oddforms.oddb.co/forms/form/${formId}/submission/document/file`,
    {
      method: "PUT",
      headers: { AccessToken: accessToken },
      body: formData,
    },
  );
  return res;
}

// ##### SALES #####

export async function getPurchases() {
  const res = await fetch(
    "https://statistics.hillheli.com/purchases/?model=HX50",
  );
  const response = await res.json();
  return response;
}

export async function getPurchasesOverview() {
  const res = await fetch(
    "https://statistics.hillheli.com/purchases/overview/",
  );
  if (res.status !== 200) {
    return null;
  }
  const response = await res.json();
  return response;
}

export async function getPurchasesInfo() {
  const res = await fetch(`${dealEndpointProd}current/`);
  const response = await res.json();
  return response;
}

export async function getSalesInfo(pid) {
  const res = await fetch(
    pid
      ? `${dealEndpointV2}sale_configurations/info/?pid=${pid}`
      : `${dealEndpointV2}sale_configurations/info/`,
  );
  const response = await res.json();
  return response;
}

export async function getPurchaseConditions(pid) {
  const empty = { conditions: [], grants: [], quantity_terms: [] };
  try {
    const res = await fetch(
      pid
        ? `${dealEndpoint}purchase/conditions/?pid=${pid}`
        : `${dealEndpoint}purchase/conditions/`,
    );
    if (!res.ok) return empty;
    const response = await res.json();
    return {
      conditions: Array.isArray(response?.conditions)
        ? response.conditions
        : [],
      grants: Array.isArray(response?.grants) ? response.grants : [],
      quantity_terms: Array.isArray(response?.quantity_terms)
        ? response.quantity_terms
        : [],
    };
  } catch {
    return empty;
  }
}

export async function getElevateFloats(pid) {
  if (!pid) return { elevateFloats: false };
  try {
    const res = await fetch(`${dealEndpoint}custom_fields/?pid=${pid}`);
    if (!res.ok) return { elevateFloats: false };
    const response = await res.json();
    return { elevateFloats: Boolean(response?.data?.elevate_floats) };
  } catch {
    return { elevateFloats: false };
  }
}

const SAMPLE_AGREEMENTS_TIMEOUT_MS = 5000;

const toAbsoluteApiUrl = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  return `${dealEndpoint}${String(url).replace(/^\/+/, "")}`;
};

/**
 * Public matrix of purchase-agreement samples.
 * Throws on failure so callers can decide how to degrade; the sale/preorder
 * pages fetch it with `.catch(() => [])` so the preview never blocks purchase.
 */
export async function getSampleAgreements() {
  const controller = new AbortController();
  const timeout = setTimeout(
    () => controller.abort(),
    SAMPLE_AGREEMENTS_TIMEOUT_MS,
  );
  try {
    const res = await fetch(`${dealEndpoint}purchase/sample-agreements/`, {
      cache: "no-store",
      signal: controller.signal,
    });
    if (!res.ok) {
      throw new Error(`Sample agreements request failed (${res.status})`);
    }
    const response = await res.json();
    const samples = Array.isArray(response?.samples) ? response.samples : [];
    return samples.map((sample) => ({
      ...sample,
      documentUrl: toAbsoluteApiUrl(sample?.document_url),
      posterUrl: toAbsoluteApiUrl(sample?.poster_url),
    }));
  } finally {
    clearTimeout(timeout);
  }
}

export async function getNextSerialNumbers() {
  try {
    const res = await fetch(`${dealEndpoint}purchase/next-serial-numbers/`);
    if (!res.ok) return {};
    const response = await res.json();
    return response && typeof response === "object" ? response : {};
  } catch {
    return {};
  }
}

export async function postSale(values) {
  const res = await fetch(`${dealEndpointV2}sales/`, {
    method: "POST",
    body: JSON.stringify(values),
    headers: { "Content-Type": "application/json" },
  });
  const response = await res.json();
  return response;
}

export async function getSale(id) {
  const res = await fetch(`${dealEndpointV2}sales/${id}/`, { method: "GET" });
  return res;
}

export async function postSaleSign(id) {
  const res = await fetch(`${dealEndpointV2}sales/${id}/sign/`, {
    method: "POST",
  });
  return res;
}

export async function saleSimulation(id, count, preOrderType) {
  const res = await fetch(`${dealEndpointV2}sales/${id}/simulation/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ quantity: count, contract_type: preOrderType }),
  });
  return res;
}

// ##### Two-Factor Authentication #####

export async function requestPhoneVerification(email, phone) {
  const res = await fetch(
    `${dealEndpointV2}two_factor_authentication/request/`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, phone }),
    },
  );
  return res;
}

export async function confirmPhoneVerificationCode(code) {
  const res = await fetch(
    `${dealEndpointV2}two_factor_authentication/confirm/`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    },
  );
  return res;
}
